import React, { memo } from 'react'
import PropTypes from 'prop-types'

import CloseIconPng from 'assets/icons/close.png'
import CloseIconSvg from 'assets/icons/close.svg'

function CloseButton({ onClick, disabled, className, size, variant }) {
  const sizeClass = size ? `close-button--${size}` : ''
  const variantClass = variant === 'modal' ? 'close-button--modal' : ''
  const iconSrc = variant === 'modal' ? CloseIconSvg : CloseIconPng

  return (
    <button
      type="button"
      className={`close-button ${
        disabled ? 'close-button--inactive' : ''
      } ${sizeClass} ${variantClass} ${className}`.trim()}
      onClick={onClick}
      disabled={disabled}
      aria-label="Close"
    >
      <img src={iconSrc} alt="" className="close-button__icon" />
    </button>
  )
}

CloseButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  size: PropTypes.string,
  variant: PropTypes.oneOf(['default', 'modal'])
}

CloseButton.defaultProps = {
  disabled: false,
  className: '',
  size: '',
  variant: 'default'
}

export default memo(CloseButton)
